// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Router from 'vue-router';
import App from './App.vue';
import 'font-awesome/css/font-awesome.min.css';
import './assets/icon/iconfont.css'; //阿里图标库
import './assets/icon/iconfont1.css'; //明细报表图标
import './assets/css/mains.css'; //css
import router from "./router";
import VCharts from 'v-charts';
import VueCropper from 'vue-cropper';

import echarts from 'echarts'//折现、饼状图引入组件
import 'echarts/map/js/china'
Vue.prototype.$echarts = echarts 
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '730adfb4d9a9ed2a8cfa4a29a1145d9b',//'AMap.ToolBar',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView',  'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor','AMap.Geolocation',
],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});

import VueAreaLinkage from 'vue-area-linkage';
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
Vue.use(VueQuillEditor);
Vue.use(VueAreaLinkage);
Vue.use(VueCropper);

Vue.use(ElementUI);
Vue.use(Router);
Vue.use(VCharts);

//自定义指令，只能输入正整数
Vue.directive('enterNumber', {
    inserted: function (el) {
        el.addEventListener("keypress",function(e){
        e = e || window.event;
        let charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;
        let re = /\d/;
        if(!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey){
            if(e.preventDefault){
                e.preventDefault();
            }else{
                e.returnValue = false;
            }                            
        }
        });
    }
});

//自定义指令，只能输入正数(包含小数)
Vue.directive('enterNumber2', {
    inserted: function (el) {
      el.addEventListener("keypress",function(e){
        e = e || window.event;
        let charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;
        console.log(charcode)
        let re = /\d/;
        if(charcode == 46){
          if(el.value.includes('.')){
            e.preventDefault();
          }
          return;
        }else if(!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey){
          if(e.preventDefault){
            e.preventDefault();
          }else{
              e.returnValue = false;
          }
        }
      });
    }
  });

// base64转blob文件
Vue.prototype.dataURItoBlob = function (dataURI) {
    var byteString = atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  },

  //将base64转换为file文件
  Vue.prototype.dataURLtoFile = function (dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while(n--){
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type:mime});
  }

  //压缩图片
  Vue.prototype.compress = function(img) {
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext('2d');
      //瓦片canvas
    let tCanvas = document.createElement("canvas");
    let tctx = tCanvas.getContext("2d");
    let initSize = img.src.length;
    let width = img.width;
    let height = img.height;
    //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
    let ratio;
    if ((ratio = width * height / 4000000) > 1) {
      console.log("大于400万像素")
      ratio = Math.sqrt(ratio);
      width /= ratio;
      height /= ratio;
    } else {
      ratio = 1;
    }
    canvas.width = width;
    canvas.height = height;
  //        铺底色
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    //如果图片像素大于100万则使用瓦片绘制
    let count;
    if ((count = width * height / 1000000) > 1) {
      console.log("超过100W像素");
      count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
  //            计算每块瓦片的宽和高
      let nw = ~~(width / count);
      let nh = ~~(height / count);
      tCanvas.width = nw;
      tCanvas.height = nh;
      for (let i = 0; i < count; i++) {
      for (let j = 0; j < count; j++) {
        tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
      }
      }
    } else {
      ctx.drawImage(img, 0, 0, width, height);
    }
    // //修复ios上传图片的时候 被旋转的问题
    // if(Orientation != "" && Orientation != 1){
    // 	switch(Orientation){
    // 	case 6://需要顺时针（向左）90度旋转
    // 		this.rotateImg(img,'left',canvas);
    // 		break;
    // 	case 8://需要逆时针（向右）90度旋转
    // 		this.rotateImg(img,'right',canvas);
    // 		break;
    // 	case 3://需要180度旋转
    // 		this.rotateImg(img,'right',canvas);//转两次
    // 		this.rotateImg(img,'right',canvas);
    // 		break;
    // 	}
    // }
    //进行最小压缩
    let ndata = canvas.toDataURL('image/jpeg', 0.5);
    console.log('压缩前：' + initSize);
    console.log('压缩后：' + ndata.length);
    console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + "%");
    tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
    return ndata;
  }

Vue.config.productionTip = false
 /**
  * 判断当前是否登录，未登录不能跳转路由
  * 防止未登录状态下直接输入路由跳转
  */
/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
    next();
});

// 引入路由
new Vue({
    el: '#app',
    store,
    router, // 注入到根实例中
    render: h => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js